import Vue from "vue"
import VueRouter from "vue-router"
import multiguard from "vue-router-multiguard"
import store from "../store"
import Home from "../views/Home.vue"
import * as role from "../views/ms/SdiRole"
import { isRoleOperator } from '../utils/commonUtils'

Vue.use(VueRouter)

const conditionalNext = function(condition) {
  return (to, from, next) => {
    if (condition) {
      next()
      return
    }
    next(false)
  }
}

const mustSuperAdmin = (to, from, next) => {
  let user_roles = store.getters["auth/user"].role.slice(1,-1).split(", ");
  if (role.isSuperAdmin(user_roles)) {
    next()
    return
  }
  next("/forbidden")
}

const mustAuthenticate = (to, from, next) => {
  if (store.getters["auth/isAuthenticated"]) {
    next()
    return
  }
  next("/login")
}

const mustAuthenticatePmse = (to, from, next) => {
  if (store.getters["auth/isAuthenticated"]) {
    next()
    return
  }
  next("/pmse")
}

const sdiUser = (to, from, next) => {
  let sdiOrganization = store.getters["auth/user"].sdiOrganization
  if ( sdiOrganization && sdiOrganization.id){
    next()
    return
  }
  next("/forbidden")
}

const mustPembinaDataAdminUser = (to, from, next) => {
  let roles = store.getters["auth/user"].role.slice(1,-1).split(", ");
  if (
    role.isPembinaDataPusat(roles) ||
    role.isPembinaDataProvinsi(roles)
  ) {
    next()
    return
  }
  next("/forbidden")
}
const mustWalidataAdminUser = (to, from, next) => {
  let roles = store.getters["auth/user"].role.slice(1,-1).split(", ");
  if (role.isPembinaData(roles)) {
    next()
    return
  }
  next("/forbidden")
}

const mustMsAdmin = (to, from, next) => {
  let roles = store.getters["auth/user"].role.slice(1,-1).split(", ");
  if (role.isPembinaData(roles) || role.isWalidata(roles) || role.isSuperAdmin(roles)) {
    next()
    return
  }
  next("/forbidden")
}
const mustMsApprover = (to, from, next) => {
  let roles = store.getters["auth/user"].role.slice(1,-1).split(", ");
  if (role.isPembinaData(roles)||  role.isSuperAdmin(roles)) {
    next()
    return
  }
  next("/forbidden")
}
const mustMsOperator = (to, from, next) => {
  let roles = store.getters["auth/user"].role.slice(1,-1).split(", ");
  if (
    role.isProdusenData(roles) ||
    role.isWalidata(roles) ||
    role.isSuperAdmin(roles)
  ) {
    next()
    return
  }
  next("/forbidden")
}

const mustPmse = (to, from, next) => {
  if (store.getters["auth/user"].role.includes("ROLE_PPMSE")) {
    next()
    return
  }
  next("/pmse-forbidden")
}
const mustPmseAdministrative = (to, from, next) => {
  if (
    store.getters["auth/user"].role.includes("ROLE_PMSE_ADMIN") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_OPERATOR") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PSTPUSAT") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PSTPROVINSI") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PSTKABKOTA")
    ) {
    next()
    return
  }
  next("/pmse-forbidden")
}
const mustPmseDashboard = (to, from, next) => {
  if (
    store.getters["auth/user"].role.includes("ROLE_PMSE_ADMIN") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_OPERATOR") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PEMANTAU") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PENGAWAS")
    ) {
    next()
    return
  }
  next("/pmse-forbidden")
}
const mustPmseKunjungan = (to, from, next) => {
  if (
    store.getters["auth/user"].role.includes("ROLE_PMSE_OPERATOR") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_ADMIN") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PSTPUSAT") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PSTPROVINSI") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PSTKABKOTA")
    ) {
    next()
    return
  }
  next("/pmse-forbidden")
}
const mustPmseStatistik = (to, from, next) => {
  if (
    store.getters["auth/user"].role.includes("ROLE_PMSE_ADMIN") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_OPERATOR") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PEMANTAU") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PEMERINTAH") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PENGAWAS") ||
    store.getters["auth/user"].role.includes("ROLE_PPMSE")
    ) {
    next()
    return
  }
  next("/pmse-forbidden")
}
const mustPmseReminder = (to, from, next) => {
  if (
    store.getters["auth/user"].role.includes("ROLE_PMSE_ADMIN") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PENGAWAS") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_OPERATOR")
    ) {
    next()
    return
  }
  next("/pmse-forbidden")
}
const mustApproved = (to, from, next) => {
  if (store.getters["pmse/getDataPerusahaan"].isApproved == 1) {
    next()
    return
  }
  next("/pmse-forbidden")
}
const mustPmseApprover = (to, from, next) => {
  if (
    store.getters["auth/user"].role.includes("ROLE_PMSE_PEMANTAU") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_ADMIN") ||
    isRoleOperator(store.getters["auth/user"].role)
  ) {
    next()
    return
  }
  next("/pmse-forbidden")
}

const mustPmsePemerintah = (to, from, next) => {
  if (
    store.getters["auth/user"].role.includes("ROLE_PMSE_PEMERINTAH")
  ) {
    next()
    return
  }
  next("/pmse-forbidden")
}

const mustPmseKl = (to, from, next) => {
  if (
    store.getters["auth/user"].role.includes("ROLE_PMSE_PENGAWAS") ||
    store.getters["auth/user"].role.includes("ROLE_PMSE_PEMERINTAH")
  ) {
    next()
    return
  }
  next("/pmse-forbidden")
}

const mustInternal = (to, from, next) => {
  if (
    store.getters["auth/user"].email.split("@")[1] == "bps.go.id"
  ) {
    next()
    return
  }
  next("/pmse-forbidden")
}

const mustSDSOperator = (to, from, next) => {
  if (
    store.getters["auth/user"].role.includes("ROLE_SDS_ADMIN") ||
    store.getters["auth/user"].role.includes("ROLE_PEMBINA_DATA_PUSAT") ||
    store.getters["auth/user"].role.includes(
      "ROLE_PEMBINA_DATA_PROVINSI"
    ) ||
    store.getters["auth/user"].role.includes(
      "ROLE_PEMBINA_DATA_KABKOTA"
    ) ||
    store.getters["auth/user"].role.includes("ROLE_WALIDATA_PUSAT") ||
    store.getters["auth/user"].role.includes("ROLE_WALIDATA_PROVINSI") ||
    store.getters["auth/user"].role.includes("ROLE_WALIDATA_KABKOTA") ||
    store.getters["auth/user"].role.includes("ROLE_PRODUSEN_DATA_PUSAT") ||
    store.getters["auth/user"].role.includes(
      "ROLE_PRODUSEN_DATA_PROVINSI"
    ) ||
    store.getters["auth/user"].role.includes("ROLE_PRODUSEN_DATA_KABKOTA")
  ) {
    next()
    return
  }
  next("/forbidden")
}
const mustSDSApprover = (to, from, next) => {
  if (
    store.getters["auth/user"].role.includes("ROLE_SDS_ADMIN") ||
    store.getters["auth/user"].role.includes("ROLE_PEMBINA_DATA_PUSAT") ||
    store.getters["auth/user"].role.includes(
      "ROLE_PEMBINA_DATA_PROVINSI"
    ) ||
    store.getters["auth/user"].role.includes(
      "ROLE_PEMBINA_DATA_KABKOTA"
    ) ||
    store.getters["auth/user"].role.includes("ROLE_WALIDATA_PUSAT") ||
    store.getters["auth/user"].role.includes("ROLE_WALIDATA_PROVINSI") ||
    store.getters["auth/user"].role.includes("ROLE_WALIDATA_KABKOTA")
  ) {
    next()
    return
  }
  next("/forbidden")
}
const mustSdpiAdmin = (to, from, next) => {
  if (store.getters["auth/user"].role.includes("ROLE_SDPI_ADMIN")) {
    next()
    return
  }
  next("/forbidden")
}

const mustSdpiOperator = (to, from, next) => {
  if (store.getters["auth/user"].role.includes("ROLE_SDPI_OPERATOR")) {
    next()
    return
  }
  next("/forbidden")
}

const mustSdpiApproval = (to, from, next) => {
  if (store.getters["auth/user"].role.includes("ROLE_SDPI_APPROVAL")) {
    next()
    return
  }
  next("/forbidden")
}

const mustSdpiMonitoring = (to, from, next) => {
  if (store.getters["auth/user"].role.includes("ROLE_SDPI_MONITORING")) {
    next()
    return
  }
  next("/forbidden")
}

const mustSshi = (to, from, next) => {
  if (store.getters["auth/user"].role.includes("ROLE_SSHI")) {
    next()
    return
  }
  next("/forbidden")
}

const mustNotAuthenticate = (to, from, next) => {
  if (!store.getters["auth/isAuthenticated"]) {
    next()
    return
  }
  next("/")
}

const routes = [
  {
    path: "/", 
    redirect: "/home",
    component: {
      render(c) {
        return c("router-view")
      },
    },
    children: [
      {
        path: "/",
        component: Home,
      },
      {
        path: "/home",
        name: "Home",
        component: Home,
      },
      {
        path: "/user",
        redirect: "/user/profile",
        component: {
          render(c) {
            return c("router-view")
          },
        },
        children: [
          {
            path: "/user/profile",
            name: "UserProfile",
            meta: { layout: "login-layout" },
            beforeEnter: multiguard([mustAuthenticate]),
            component: () =>
              import("../views/pengaturan/ChangePassword.vue"),
          },
          {
            path: "/user/change-password",
            name: "ChangePasswordr",
            meta: { layout: "login-layout" },
            beforeEnter: multiguard([mustAuthenticate]),
            component: () =>
              import("../views/pengaturan/ChangePassword.vue"),
          },
        ],
      },

      {
        path: "pengaturan",
        redirect: "/pengaturan",
        name: "Setting",
        
        component: {
          render(c) {
            return c("router-view")
          },
        },
        children: [
          {
            path: "/pengaturan/user",
            name: "UserSetting",
            beforeEnter: multiguard([mustAuthenticate, mustSuperAdmin]),
            meta: { layout: "setting-layout" },
            component: () => import("../views/pengaturan/User.vue"),
          },
          {
            path: "/pengaturan/sdi/pembina-data/:id/user",
            name: "PembinaDataUser",
            beforeEnter: conditionalNext(
              mustAuthenticate &&
                sdiUser &&
                (mustSuperAdmin || mustPembinaDataAdminUser)
            ),
            meta: { layout: "app-layout" },
            component: () => import("../views/pengaturan/SdiUser.vue"),
          },
          {
            path: "/pengaturan/sdi/walidata/:id/user",
            name: "WalidataDataUser",
            beforeEnter: conditionalNext(
              mustAuthenticate &&
                sdiUser &&
                (mustSuperAdmin || mustWalidataAdminUser)
            ),
            meta: { layout: "app-layout" },
            component: () => import("../views/pengaturan/SdiUser.vue"),
          },
          {
            path: "/pengaturan/sdi/organization",
            name: "SDIOrganizationUser",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsAdmin,
              sdiUser,
            ]),
            meta: { layout: "setting-layout" },
            component: () =>
              import("../views/pengaturan/SdiOrganization.vue"),
          },
        ],
      },
      {
        path: "metadata",
        redirect: "/metadata-dashboard",
        name: "MS",
        component: {
          render(c) {
            return c("router-view")
          },
        },
        children: [
          {
            path: "/metadata/usulan-metadata",
            name: "AddMsKeg",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsOperator,
              sdiUser,
            ]),
            // beforeEnter: conditionalNext(mustSdpiAdmin || mustSdpiOperator || mustSdpiApproval || mustSdpiMonitoring),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsKeg.vue"),
          },
          {
            path: "/metadata/view-kegiatan/:id",
            name: "MSMetadataDetail",
            beforeEnter: conditionalNext(
              mustAuthenticate &&
                sdiUser &&
                (mustMsOperator || mustMsApprover)
            ),
            meta: { layout: "ms-layout" },
            component: () => import("../views/ms/usulan/ViewMsKeg.vue"),
          },
          {
            path: "/metadata/update-kegiatan/:id",
            name: "UpdateMsKeg",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsOperator,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsKeg.vue"),
          },
          {
            path: "/metadata/add-cycle-kegiatan/:id",
            name: "CycleMsKeg",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsOperator,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsKeg.vue"),
          },
          {
            path: "/metadata/usulan/kegiatan/:id/variabel",
            name: "AddMsVar",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsOperator,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsVar.vue"),
          },
          {
            path: "/metadata/update-variabel/:id",
            name: "UpdateMsVar",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsOperator,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsVar.vue"),
          },
          {
            path: "/metadata/view-variabel/:id",
            name: "ViewMsVar",
            beforeEnter: multiguard([
              mustAuthenticate,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsVar.vue"),
          },

          {
            path: "/metadata/usulan/kegiatan/:id/indikator",
            name: "AddMsInd",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsOperator,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsInd.vue"),
          },
          {
            path: "/metadata/update-indikator/:id",
            name: "UpdateMsInd",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsOperator,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsInd.vue"),
          },
          {
            path: "/metadata/view-indikator/:id",
            name: "ViewMsInd",
            beforeEnter: multiguard([
              mustAuthenticate,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsInd.vue"),
          },
          {
            path: "/metadata-dashboard",
            name: "MSDashboard",
            beforeEnter: multiguard([mustAuthenticate, sdiUser]),
            meta: { layout: "ms-layout" },
            component: () => import("../views/ms/Dashboard.vue"),
            props:{}
          },
          {
            path: "/metadata/summary",
            name: "MSSummary",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsOperator,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () => import("../views/ms/summary/Index.vue"),
          },
          {
            path: "/metadata/pemeriksaan",
            name: "MSApproval",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsApprover,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () => import("../views/ms/approval/IndexV2.vue"),
          },
          {
            path: "/metadata/pemeriksaan/kegiatan/:id",
            name: "ApproveMsKeg",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsApprover,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/approval/ApproveMsKeg.vue"),
          },
          {
            path: "/metadata/pemeriksaan/variabel/:id",
            name: "ApproveMsVar",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsApprover,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsVar.vue"),
          },
          {
            path: "/metadata/pemeriksaan/indikator/:id",
            name: "ApproveMsInd",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsApprover,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/ms/usulan/CreateUpdateMsInd.vue"),
          },
          {
            path: "/metadata/panduan",
            name: "MSPanduan",
            beforeEnter: multiguard([mustAuthenticate, sdiUser]),
            meta: { layout: "ms-layout" },
            component: () => import("../views/ms/panduan/Index.vue"),
          },
          {
            path: "/metadata/pengaturan",
            name: "MSPengaturan",
            beforeEnter: multiguard([
              mustAuthenticate,
              mustMsAdmin,
              sdiUser,
            ]),
            meta: { layout: "ms-layout" },
            component: () =>
              import("../views/pengaturan/SdiOrganization.vue"),
          },

          // {
          //     path: "/metadata/pengaturan/instansi",
          //     name: "MSPengaturanInstansi",
          //     beforeEnter: multiguard([mustAuthenticate, mustMsAdmin, sdiUser]),
          //     // beforeEnter: conditionalNext(mustMsApprover || mustMsOperator),
          //     meta: { layout: "ms-layout" },
          //     component: () =>
          //         import("../views/ms/pengaturan/instansi/Index.vue"),
          // },
          // {
          //     path: "/metadata/pengaturan/pengguna",
          //     name: "MSPengaturanPengguna",
          //     beforeEnter: multiguard([mustAuthenticate, mustMsAdmin, sdiUser]),
          //     // beforeEnter: conditionalNext(mustMsApprover || mustMsOperator),
          //     meta: { layout: "ms-layout" },
          //     component: () =>
          //         import("../views/ms/pengaturan/pengguna/Index.vue"),
          // },
        ],
      },

      {
        path: "standar-data-statistik",
        redirect: "/standar-data-statistik-nasional",
        component: {
          render(c) {
            return c("router-view")
          },
        },
        children: [
          {
            path: "/standar-data-statistik-nasional",
            name: "SDSN",
            meta: { layout: "sds-layout" },
            component: () => import("../views/sds/Index.vue"),
          },
          {
            path: "/standar-data-statistik/daftar-usulan",
            name: "SdsItemList",
            meta: { layout: "sds-layout" },
            beforeEnter: multiguard([
              mustAuthenticate,
              mustSDSOperator,
              sdiUser,
            ]),
            component: () => import("../views/sds/usulan/Index.vue"),
          },
          {
            path: "/standar-data-statistik/buat-usulan",
            name: "CreateSdsItem",
            meta: { layout: "sds-layout" },
            beforeEnter: multiguard([
              mustAuthenticate,
              mustSDSOperator,
              sdiUser,
            ]),
            component: () => import("../views/sds/usulan/CreateV2.vue"),
          },
          {
            path: "/standar-data-statistik/lihat-detail-usulan/:id",
            name: "ViewSdsItemV2",
            meta: { layout: "sds-layout" },
            beforeEnter: multiguard([
              mustAuthenticate,
              mustSDSOperator,
              sdiUser,
            ]),
            component: () => import("../views/sds/usulan/ViewV2.vue"),
          },
          {
            path: "/standar-data-statistik/edit-usulan/:id",
            name: "UpdateSdsItem",
            meta: { layout: "sds-layout" },
            beforeEnter: multiguard([
              mustAuthenticate,
              mustSDSOperator,
              sdiUser,
            ]),
            component: () => import("../views/sds/usulan/UpdateV2.vue"),
          },
          {
            path: "/standar-data-statistik/daftar-pemeriksaan",
            name: "ApprovalList",
            meta: { layout: "sds-layout" },
            beforeEnter: multiguard([
              mustAuthenticate,
              mustSDSApprover,
              sdiUser,
            ]),
            component: () => import("../views/sds/approval/Index.vue"),
          },
          {
            path: "/standar-data-statistik/pemeriksaan/:id",
            name: "ApprovalSds",
            meta: { layout: "sds-layout" },
            beforeEnter: multiguard([
              mustAuthenticate,
              mustSDSApprover,
              sdiUser,
            ]),
            component: () =>
              import("../views/sds/approval/ApprovalV2.vue"),
          },
          {
            path: "/standar-data-statistik/report",
            name: "ReportSds",
            meta: { layout: "sds-layout" },
            beforeEnter: multiguard([mustAuthenticate, sdiUser]),
            component: () => import("../views/sds/Report.vue"),
          },
          {
            path: "/standar-data-statistik/panduan",
            name: "SdsDocumentation",
            meta: { layout: "sds-layout" },
            beforeEnter: multiguard([mustAuthenticate]),
            component: () => import("../views/sds/Documentation.vue"),
          },
          {
            path: "/standar-data-statistik/dashboard",
            name: "DashboardSds",
            meta: { layout: "sds-layout" },
            beforeEnter: multiguard([mustAuthenticate, sdiUser]),
            component: () => import("../views/sds/Dashboard.vue"),
          },
          {
            path: "/standar-data-statistik/setting",
            name: "SettingSds",
            meta: { layout: "sds-layout" },
            beforeEnter: multiguard([mustAuthenticate, sdiUser]),
            component: () =>
              import("../views/pengaturan/SdiOrganization.vue"),
          },
        ],
      },

      {
        path: "sdpi",
        redirect: "/sdpi",
        name: "SDPI",
        component: {
          render(c) {
            return c("router-view")
          },
        },
        children: [
          {
            path: "/sdpi",
            name: "SDPIIndex",
            beforeEnter: conditionalNext(
              mustSdpiAdmin ||
                mustSdpiOperator ||
                mustSdpiApproval ||
                mustSdpiMonitoring
            ),
            meta: { layout: "sdpi-layout" },
            component: () => import("../views/sdpi/beranda/Index.vue"),
          },
          {
            path: "/sdpi/entri-konfirmasi/:id",
            name: "SDPIEntriKonfirmasi",
            meta: { layout: "sdpi-layout" },
            component: () => import("../views/sdpi/konfirmasi/Entri.vue"),
          },
          {
            path: "/sdpi/entri-konfirmasi-kk-tidak-valid/:kode_sls/:nama",
            name: "SDPIEntriKonfirmasiKkTidakValid",
            meta: { layout: "sdpi-layout" },
            component: () =>
              import("../views/sdpi/konfirmasi/EntriKkTidakValid.vue"),
          },
          {
            path: "/sdpi/kuesioner-konfirmasi/:kode_sls/:nomor_kk",
            name: "SDPIKuesionerKonfirmasi",
            meta: { layout: "sdpi-layout" },
            component: () =>
              import("../views/sdpi/konfirmasi/Kuesioner.vue"),
          },
          {
            path:
              "/sdpi/kuesioner-konfirmasi-kk-tidak-valid/:kode_sls/:nama",
            name: "SDPIKuesionerKonfirmasiKkTidakValid",
            meta: { layout: "sdpi-layout" },
            component: () =>
              import("../views/sdpi/konfirmasi/KuesionerKkTidakValid.vue"),
          },
          //LAMA
          {
            path: "/sdpi/dashboard-indicator",
            meta: { layout: "sdpi-layout" },
            component: () => import("../views/sdpi/dashboard/Index.vue"),
          },
          {
            path: "/sdpi/dashboard-indicator/:prov",
            meta: { layout: "sdpi-layout" },
            component: () => import("../views/sdpi/dashboard/MapProv.vue"),
          },
          {
            path: "/sdpi/dashboard-indicator/:prov/:kab",
            meta: { layout: "sdpi-layout" },
            component: () => import("../views/sdpi/dashboard/MapKab.vue"),
          },
          {
            path: "/sdpi/dashboard-indicator/:prov/:kab/:kec",
            meta: { layout: "sdpi-layout" },
            component: () => import("../views/sdpi/dashboard/MapKec.vue"),
          },
          {
            path: "/sdpi/dashboard-indicator/:prov/:kab/:kec/:desa",
            meta: { layout: "sdpi-layout" },
            component: () => import("../views/sdpi/dashboard/MapDesa.vue"),
          },
          {
            path: "/sdpi/monitoring-evaluasi",
            meta: { layout: "sdpi-layout" },
            beforeEnter: conditionalNext(
              mustSdpiAdmin ||
                mustSdpiOperator ||
                mustSdpiApproval ||
                mustSdpiMonitoring
            ),
            component: () => import("../views/sdpi/monev/Index.vue"),
          },
          {
            path: "/sdpi/monitoring-evaluasi/:prov",
            meta: { layout: "sdpi-layout" },
            component: () => import("../views/sdpi/monev/MapProv.vue"),
          },
          {
            path: "/sdpi/konfirmasi",
            meta: { layout: "sdpi-layout" },
            beforeEnter: conditionalNext(
              mustSdpiOperator || mustSdpiApproval
            ),
            component: () => import("../views/sdpi/konfirmasi/Index.vue"),
          },
          {
            path: "/sdpi/approval",
            meta: { layout: "sdpi-layout" },
            beforeEnter: conditionalNext(mustSdpiApproval),
            component: () => import("../views/sdpi/approval/Index.vue"),
          },
        ],
      },
      // {
      //   path: "sshi_",
      //   redirect: "/sshi_",
      //   name: "sshi_",
      //   component: {
      //     render(c) {
      //       return c("router-view")
      //     },
      //   },
      //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
      //   children: [
      //     {
      //       path: "/sshi_",
      //       name: "sshi-index",
      //       meta: { layout: "sshi-layout" },
      //       component: () => import("../views/sshi_/beranda/Index.vue"),
      //     },
      //     {
      //       path: "/sshi_/monitoring-evaluasi",
      //       name: "sshi-monitoring-evaluasi",
      //       meta: { layout: "sshi-layout" },
      //       component: () =>
      //         import("../views/sshi_/monitoring-evaluasi/Index.vue"),
      //     },
      //     {
      //       path: "/sshi_/daftar-keluarga",
      //       name: "sshi-daftar-keluarga",
      //       meta: { layout: "sshi-layout" },
      //       component: () =>
      //         import("../views/sshi_/daftar-keluarga/Index.vue"),
      //     },
      //     {
      //       path: "/sshi_/uc-sshi2022-gc1/:id",
      //       name: "sshi-uc-gc1",
      //       meta: { layout: "sshi-layout" },
      //       component: () => import("../views/sshi_/uc-gc1/Index.vue"),
      //     },
      //     {
      //       path: "/sshi_/uc-sshi2022-gc2/:id",
      //       name: "sshi-uc-gc2",
      //       meta: { layout: "sshi-layout" },
      //       component: () => import("../views/sshi_/uc-gc2/Index.vue"),
      //     },
      //   ],
      // },
      {
        path: "sshi",
        redirect: "/sshi",
        name: "sshi",
        component: {
          render(c) {
            return c("router-view")
          },
        },
        children: [
          {
            path: "/sshi",
            name: "sshi-index",
            meta: { layout: "sshi-layout" },
            // beforeEnter: multiguard([mustAuthenticate, mustSshi]),
            component: () => import("../views/sshi2024/beranda/Index.vue"),
          },
                    {
            path: "/sshi/tentang",
            name: "sshi-about",
            meta: { layout: "sshi-layout" },
            // beforeEnter: multiguard([mustAuthenticate, mustSshi]),
            component: () => import("../views/sshi2024/beranda/About.vue"),
          },
          // {
          //   path: "/sshi/struktur-penduduk",
          //   name: "sshi-struktur-penduduk",
          //   meta: { layout: "sshi-layout" },
          //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
          //   component: () => import("../views/sshi2024/struktur-penduduk/Index.vue"),
          // },
          {
            path: "/sshi/katalog-data",
            name: "sshi-katalog-data",
            meta: { layout: "sshi-layout" },
            props: { projectName: 'sshi' },
            // beforeEnter: multiguard([mustAuthenticate, mustSshi]),
            component: () => import("../views/data/Data.vue"),
          },
          {
            path: "/sshi/news/manajemen",
            name: "sshi-news-manajemen",
            meta: { layout: "sshi-layout" },
            props: { projectName: 'sshi' },
            beforeEnter: multiguard([mustAuthenticate, mustSshi]),
            component: () => import("../views/sshi2024/news/Manajemen.vue"),
          },
          {
            path: "/sshi/news",
            name: "sshi-news",
            meta: { layout: "sshi-layout" },
            props: { projectName: 'sshi' },
            // beforeEnter: multiguard([mustAuthenticate, mustSshi]),
            component: () => import("../views/news/Index.vue"),
          },
          {
            path: "/sshi/news/:slug",
            name: "sshi-news-slug",
            meta: { layout: "sshi-layout" },
            props: { projectName: 'sshi' },
            // beforeEnter: multiguard([mustAuthenticate, mustSshi]),
            component: () => import("../views/news/Detail.vue"),
          },
                    {
            path: "/sshi/news/editor/:id",
            name: "sshi-news-editor",
            meta: { layout: "sshi-layout" },
            props: { projectName: 'sshi' },
            beforeEnter: multiguard([mustAuthenticate, mustSshi]),
            component: () => import("../views/sshi2024/news/Editor.vue"),
          },
          {
            path: "/sshi/data/data-view/:id",
            name: "sshi-view-data",
            meta: { layout: "sshi-layout" },
            // beforeEnter: multiguard([mustAuthenticate, mustSshi]),
            component: () => import("../views/data/DataViews.vue"),
          },
          // {
          //   path: "/sshi/fertilitas",
          //   name: "sshi-fertilitas",
          //   meta: { layout: "sshi-layout" },
          //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
          //   component: () => import("../views/sshi2024/fertilitas/Index.vue"),
          // },
          // {
          //   path: "/sshi/mortalitas",
          //   name: "sshi-mortalitas",
          //   meta: { layout: "sshi-layout" },
          //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
          //   component: () => import("../views/sshi2024/mortalitas/Index.vue"),
          // },
          // {
          //   path: "/sshi/mobilitas",
          //   name: "sshi-mobilitas",
          //   meta: { layout: "sshi-layout" },
          //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
          //   component: () => import("../views/sshi2024/mobilitas/Index.vue"),
          // },
          // {
          //   path: "/sshi/administrasi-penduduk",
          //   name: "sshi-administrasi",
          //   meta: { layout: "sshi-layout" },
          //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
          //   component: () => import("../views/sshi2024/administrasi/Index.vue"),
          // },
          // {
          //   path: "/sshi/analisis-lanjutan/peta",
          //   name: "sshi-analisis-lanjutan-peta",
          //   meta: { layout: "sshi-layout" },
          //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
          //   component: () => import("../views/sshi2024/analisis-lanjutan/peta/IndoProv.vue"),
          // },
          // {
          //   path: "/sshi/analisis-lanjutan/peta/:idprov",
          //   name: "sshi-analisis-lanjutan-peta",
          //   meta: { layout: "sshi-layout" },
          //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
          //   component: () => import("../views/sshi2024/analisis-lanjutan/peta/ProvKab.vue"),
          // },
          // {
          //   path: "/sshi/analisis-lanjutan/tabel",
          //   name: "sshi-analisis-lanjutan-tabel",
          //   meta: { layout: "sshi-layout" },
          //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
          //   component: () => import("../views/sshi2024/analisis-lanjutan/Tabel.vue"),
          // },
          // {
          //   path: "/sshi/unggah",
          //   name: "sshi-upload",
          //   meta: { layout: "sshi-layout" },
          //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
          //   component: () => import("../views/sshi2024/unggah/Upload.vue"),
          // },
          {
            path: "/sshi/tabel-dinamis/v3",
            name: "SshiToolsTabelDinamis3",
            meta: { layout: "sshi-layout" },
            props: { projectName: 'sshi' },
            // beforeEnter: multiguard([mustAuthenticate, mustSshi]),
            component: () =>
              import("../views/tabel-dinamis/TabelDinamis.vue"),
          },
        ],
      },
      // {
      //   path: "sshi2023",
      //   redirect: "/sshi2023/dashboard",
      //   name: "sshi2023",
      //   component: {
      //     render(c) {
      //       return c("router-view")
      //     },
      //   },
      //   beforeEnter: multiguard([mustAuthenticate, mustSshi]),
      //   children: [
      //     {
      //       path: "/sshi2023/dashboard",
      //       name: "DashboardSSHI",
      //       component: () => import("../views/sshi2023/dashboard/Dashboard.vue"),
      //     },
      //     {
      //       path: "/sshi2023/beranda",
      //       name: "BerandaSSHI",
      //       meta: { layout: "sshi-layout-baru" },
      //       component: () => import("../views/sshi2023/beranda/Index.vue"),
      //     },
      //     {
      //       path: "/sshi2023/upload",
      //       meta: { layout: "sshi-layout-baru" },
      //       name: "UploadData",
      //       component: () => import("../views/sshi2023/dashboard/Upload.vue"),
      //     },
      //     {
      //       path: "/sshi2023/struktur-penduduk",
      //       name: "StrukturPenduduk",
      //       component: () => import("../views/sshi2023/dashboard/Chart.vue"),
      //     },
      //     {
      //       path: "/sshi2023/fertilitas",
      //       name: "ChartFertilitas",
      //       component: () => import("../views/sshi2023/dashboard/Chart2.vue"),
      //     },
      //     {
      //       path: "/sshi2023/mortalitas",
      //       name: "ChartMortalitas",
      //       component: () => import("../views/sshi2023/dashboard/Chart3.vue"),
      //     },
      //     {
      //       path: "/sshi2023/mobilitas",
      //       name: "Map",
      //       component: () => import("../views/sshi2023/dashboard/Map.vue"),
      //     },
      //     {
      //       path: "/sshi2023/dk/:id/:id2",
      //       name: "sshi-dk",
      //       //meta: { layout: "sshi-layout" },
      //       component: () => import("../views/sshi2023/dk/DK.vue"),
      //     },
          
      //     {
      //       path: "/sshi2023/daftar-keluarga",
      //       name: "sshi-daftar-keluarga",
      //       meta: { layout: "sshi-layout-baru" },
      //       component: () =>
      //         import("../views/sshi2023/daftar-keluarga/Index.vue"),
      //     },
      //     {
      //       path: "/sshi2023/uc-gc1/:id",
      //       name: "sshi-uc-gc1",
      //       meta: { layout: "sshi-layout-baru" },
      //       component: () => import("../views/sshi2023/uc-gc1/Index.vue"),
      //     },
      //     {
      //       path: "/sshi2023/uc-gc2/:id",
      //       name: "sshi-uc-gc2",
      //       meta: { layout: "sshi-layout-baru" },
      //       component: () => import("../views/sshi2023/uc-gc2/Index.vue"),
      //     },
      //   ]
      // },
      {
        path: "pmse",
        redirect: "/pmse",
        name: "PMSE",
        component: {
          render(c) {
            return c("router-view")
          },
        },
        // beforeEnter: multiguard([mustAuthenticate, mustSdski]),
        children: [
          {
            path: "/",
            name: "PMSEIndex",
            meta: { layout: "pmse-layout" },
            component: () => import("../views/pmse/home/Index.vue"),
          },
          // {
          //   path: "/pmse/pengaturan/user/change-password",
          //   name: "ChangePasswordPmse",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([mustAuthenticatePmse]),
          //   component: () =>
          //     import("../views/pengaturan/ChangePassword.vue"),
          // },
          // {
          //   path: "/pmse/pengaturan/user",
          //   name: "PMSEPengaturanUser",
          //   beforeEnter: multiguard([mustAuthenticatePmse, mustPmseAdministrative]),
          //   meta: { layout: "pmse-layout" },
          //   component: () => import("../views/pmse/administrasi/User.vue"),
          // },
          // {
          //   path: "/pmse/perekaman-data",
          //   name: "PMSEPerekamanData",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([
          //     mustAuthenticatePmse,
          //     mustPmse,
          //     mustApproved,
          //   ]),
          //   component: () =>
          //     import("../views/pmse/perekaman-data/Index.vue"),
          // },
          // {
          //   path: "/pmse/approval-data",
          //   name: "PMSEApprovalData",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([
          //     mustAuthenticatePmse,
          //     mustPmseApprover
          //   ]),
          //   component: () =>
          //     import("../views/pmse/perekaman-data/ApprovalData.vue"),
          // },
          // {
          //   path: "/pmse/show-data/:documentid",
          //   name: "PMSEViewData",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([
          //     mustAuthenticatePmse,
          //     mustPmseApprover
          //   ]),
          //   component: () =>
          //     import("../views/pmse/perekaman-data/ViewUpload.vue"),
          // },
          // {
          //   path: "/pmse/visit",
          //   name: "PMSEVisit",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([
          //     mustAuthenticatePmse,
          //     mustPmseKunjungan
          //   ]),
          //   component: () => import("../views/pmse/visit/Index.vue"),
          // },
          // {
          //   path: "/pmse/dashboard-profil",
          //   name: "PMSEDashboard",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([
          //     mustAuthenticatePmse,
          //     mustPmseDashboard
          //   ]),
          //   component: () => import("../views/pmse/dashboard/DashboardProfil.vue"),
          // },
          // {
          //   path: "/pmse/dashboard-pemasukan",
          //   name: "PMSEDashboardPemasukan",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([
          //     mustAuthenticatePmse,
          //     mustPmseDashboard
          //   ]),
          //   component: () => import("../views/pmse/dashboard/DashboardPemasukan.vue"),
          // },
          // {
          //   path: "/pmse/pusat-bantuan",
          //   name: "PMSEPusatBantuan",
          //   meta: { layout: "pmse-layout" },
          //   component: () =>
          //     import("../views/pmse/pusat-bantuan/Index.vue"),
          // },
          // {
          //   path: "/pmse/pusat-bantuan-admin",
          //   name: "PMSEPusatBantuanAdmin",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([
          //     mustAuthenticatePmse,
          //     mustPmseAdministrative
          //   ]),
          //   component: () =>
          //   import("../views/pmse/administrasi/PusatBantuan.vue"),
          // },
          // {
          //   path: "/pmse/peraturan",
          //   name: "PMSEPeraturan",
          //   meta: { layout: "pmse-layout" },
          //   component: () =>
          //     import("../views/pmse/peraturan/Index.vue"),
          // },
          // {
          //   path: "/pmse/daftar-pengguna",
          //   name: "PMSERegister",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([mustNotAuthenticate]),
          //   component: () =>
          //     import("../views/pmse/authentication/Register.vue"),
          // },
          // {
          //   path: "/pmse/ubah-profil",
          //   name: "PMSEUpdateProfile",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([mustAuthenticatePmse, mustPmse]),
          //   component: () =>
          //     import("../views/pmse/authentication/UpdatingProfile.vue"),
          // },
          // {
          //   path: "/pmse/ubah-profil-kl",
          //   name: "PMSEUpdateProfileKl",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([mustAuthenticatePmse, mustPmseKl]),
          //   component: () =>
          //     import("../views/pmse/authentication/UpdatingProfileKl.vue"),
          // },
          // {
          //   path: "/pmse/ubah-profil-bps",
          //   name: "PMSEUpdateProfileBps",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([mustAuthenticatePmse, mustInternal]),
          //   component: () =>
          //     import("../views/pmse/authentication/UpdatingProfileBps.vue"),
          // },
          // {
          //   path: "/pmse/approve-profil",
          //   name: "PMSEApproveProfile",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([
          //     mustAuthenticatePmse,
          //     mustPmseApprover
          //   ]),
          //   component: () =>
          //     import("../views/pmse/authentication/Approval.vue"),
          // },
          // {
          //   path: "/pmse/periode",
          //   name: "PMSEPeriode",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([
          //     mustAuthenticatePmse,
          //     mustPmseAdministrative
          //   ]),
          //   component: () =>
          //     import("../views/pmse/administrasi/Periode.vue"),
          // },
          // {
          //   path: "/pmse/statistik",
          //   name: "PMSEStatistik",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([mustAuthenticatePmse, mustPmseStatistik]),
          //   component: () => import("../views/pmse/statistik/Index.vue"),
          // },
          // {
          //   path: "/pmse/pengaturan/kl",
          //   name: "PMSEKl",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([mustAuthenticatePmse, mustPmseAdministrative]),
          //   component: () => import("../views/pmse/administrasi/Kl.vue"),
          // },
          // {
          //   path: "/pmse/pengaturan/kontakbps",
          //   name: "PMSEKontakBps",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([mustAuthenticatePmse, mustPmseAdministrative]),
          //   component: () => import("../views/pmse/administrasi/KontakBps.vue"),
          // },
          // {
          //   path: "/pmse/reminder",
          //   name: "PMSEReminder",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([mustAuthenticatePmse, mustPmseReminder]),
          //   component: () => import("../views/pmse/administrasi/Reminder.vue"),
          // },
          // {
          //   path: "/pmse/profil",
          //   name: "PMSEProfil",
          //   meta: { layout: "pmse-layout" },
          //   beforeEnter: multiguard([mustAuthenticatePmse, mustPmsePemerintah]),
          //   component: () => import("../views/pmse/administrasi/Profil.vue"),
          // },

        ],
      },
      {
        path: "/verify-user/:code",
        name: "Verify User",
        meta: { layout: "login-layout" },
        component: () =>
          import("../views/pmse/authentication/EmailVerify.vue"),
      },
      {
        path: "/reset-password/:code",
        name: "Reset Password",
        meta: { layout: "login-layout" },
        component: () =>
          import("../views/pmse/authentication/ResetPassword.vue"),
      },
      {
        path: "/pmse-forbidden",
        name: "ForbiddenPmse",
        meta: { layout: "login-layout" },
        component: () => import("../views/error/403Pmse.vue"),
      },
      {
        path: "/authcheck",
        name: "AuthCheck",
        component: () => import("../views/autentikasi/AuthCheck.vue"),
        beforeEnter: mustNotAuthenticate,
      },
      {
        path: "/login",
        name: "Login",
        meta: { layout: "login-layout" },
        component: () => import("../views/autentikasi/Login.vue"),
        beforeEnter: mustNotAuthenticate,
      },
      {
        path: "/logout",
        name: "Logout",
        component: () => import("../views/autentikasi/Logout.vue"),
        beforeEnter: mustAuthenticate,
      },
      {
        path: "/logout-pmse",
        name: "LogoutPmse",
        component: () => import("../views/autentikasi/LogoutPmse.vue"),
        beforeEnter: mustAuthenticate,
      },
      {
        path: "/content-management",
        name: "CMS",
        meta: { layout: "cms-layout" },
        component: () => import("../views/cms/Index.vue"),
      },
      {
        path: "/forbidden",
        name: "Forbidden",
        meta: { layout: "login-layout" },
        component: () => import("../views/error/403.vue"),
      },
      {
        path: "*",
        name: "Not Found",
        meta: { layout: "login-layout" },
        component: () => import("../views/error/404.vue"),
      },
      {
        path: "/data-catalog",
        redirect:"/people",
        component: () => import("../views/error/403.vue"),
      }
    ],
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
  
})

// router.beforeEach((to, from, next) => {
//   if (to.name == "Login" && !store.getters["auth/isAuthenticated"]) next();
//   else if (to.name !== "AuthCheck" && !store.getters["auth/isAuthenticated"])
//     next({ name: "AuthCheck" });
//   else next();
// });

export default router
